import { TextsLanguages } from '@types'

export const useTexts = (lang: TextsLanguages = 'pt-br') => {
  const texts = {
    'pt-br': {
      title: 'Fique **sempre atualizado** sobre seus clientes',
      description:
        'Receba notificações em tempo real sobre mudanças de status, cadastros e pedidos. Assim, você acompanha tudo de perto.',
      submit: 'Ativar Notificações',
    },
  }

  return texts[lang]
}
